import { Box, Stack, Icon, Flex, Tooltip } from '@wegroup/design-system';
import { Link as RRLink } from 'react-router-dom';
import React from 'react';
import {
  useFlowsDispatch,
  useFlowsSelector,
} from '../../../../../../../common/src/utils/globalVariables';
import { setShowBrokerInfoModal } from '../../../../../store/redux/slices/flowsMetaDataSlice';
import { useTranslation } from 'react-i18next';
import ToolbarIconButton from './ToolbarIconButton';
import SmallToolbar from './SmallToolbar';
import { useLocation } from 'react-router';
import AskLaterQuestionsToolbarButton from '../ask-later-questions/AskLaterQuestionsToolbarButton';
import ErrorBoundary from '../../../../../../../app/src/components/ErrorBoundary';
import ResetCompanyScanToolbarButton from '../ask-later-questions/ResetCompanyScanToolbarButton';
import usePartyId from '../../../../../../../common/src/hooks/query-params/usePartyId';
import FlowLanguageChangeMenu from './FlowLanguageChangeMenu';
import { isSocialLoginUrl } from '../../../../../../../app/src/features/authentication/constants/SocialAuth';

const CompanyScanSmallToolbar: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const hasUrlPartyId = !!usePartyId();
  const isViewModeOnly = useFlowsSelector(
    (state) => state.flows.isViewOnlyModeOn,
  );

  const isUserInFlow = pathname.includes('/flows');

  const flowsDispatch = useFlowsDispatch();

  const handleOnHelpClick = () => {
    flowsDispatch(setShowBrokerInfoModal(true));
  };

  return (
    <SmallToolbar>
      <Flex
        flexDir={{ base: 'row', laptop: 'column' }}
        flexGrow={1}
        justify="space-between"
        mt={{ base: '0', laptop: '4' }}
      >
        <Stack direction={{ base: 'row', laptop: 'column' }} spacing="2">
          {!isSocialLoginUrl && !isViewModeOnly && (
            <Tooltip placement="right" label={t('BACK-TO-DASHBOARD')}>
              <Box>
                <ToolbarIconButton
                  as={RRLink}
                  to="/dashboard"
                  aria-label="Go to dashboard"
                  icon={
                    <Icon
                      color="secondary.300"
                      boxSize="7"
                      name="GeneralActionsReturn"
                    />
                  }
                />
              </Box>
            </Tooltip>
          )}
          {(isUserInFlow || hasUrlPartyId) &&
            !isSocialLoginUrl &&
            !isViewModeOnly && <ResetCompanyScanToolbarButton />}
        </Stack>

        <Stack direction={{ base: 'row', laptop: 'column' }} spacing="2">
          {isUserInFlow && !isSocialLoginUrl && (
            <ErrorBoundary>
              <AskLaterQuestionsToolbarButton />
            </ErrorBoundary>
          )}
          <FlowLanguageChangeMenu />
          {isSocialLoginUrl && (
            <ToolbarIconButton
              onClick={handleOnHelpClick}
              aria-label="Show broker info"
              icon={
                <Icon
                  name="GeneralActionsQuestion"
                  color="secondary.300"
                  boxSize="7"
                />
              }
            />
          )}
        </Stack>
      </Flex>
    </SmallToolbar>
  );
};

export default CompanyScanSmallToolbar;
